<template>
  <div class="fillinformation">
    <div class="header">
      <enterprise-header></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:1280px;background:#ffffffcf;margin:17px auto;margin-bottom:20px;border-radius: 4px">
          <div class="invitationlink">
            <div style="padding-top:105px;height:32px;">
              <steps ref="stepsChild"></steps>
            </div>
            <el-form ref="enterpriseForm" :model="enterpriseForm" :rules="rules" label-position="left" label-width="0px"
              class="demo-ruleForm register-page" size="small">
              <div class="qualificationinfor">
                <div>
                  <p style="width:2px;height:12px;background:var(--theme-color);border-radius:8px;display:inline-block;"></p>
                  <span style="color:#323232;font-size:16px">企业资质信息</span>
                </div>
                <div style="margin-left:61px;margin-top:50px">
                  <p style="color:#2E384D;font-size:14px;margin-bottom: 7px;">
                    <span style="color:#F56C6C">*</span>企业全称：
                  </p>
                  <el-form-item prop="enterpriseName">
                    <el-input v-model.trim="enterpriseForm.enterpriseName" maxlength="30" minlength="1"
                      placeholder="请输入企业全称" style="width:962px" size="small" @keydown.native="keydown($event)">
                    </el-input>
                    <p style="font-size:12px;color:var(--info-color)9;height: 16px;line-height: 15px;margin-top:10px">
                      主体名称需严格按照证件填写，在创建完成后不可更改.
                    </p>
                  </el-form-item>
                </div>
                <div style="margin-left:61px;margin-top:50px">
                  <p style="color:#2E384D;font-size:14px;display:inline-block;">
                    <span style="color:#F56C6C">*</span>工商营业执照：
                  </p>
                  <div style="display:inline-block;vertical-align:top;width:80%">
                    <el-form-item prop="file">
                      <el-upload :disabled="disabledone1" class="dataUpload" :action="action" :limit="2"
                        :on-success="dataOnSuccess1" :on-remove="dataOnRemove1" :before-upload="dataprogress1"
                        :headers="headers" :file-list="fileList1">
                        <el-button :disabled="disabledone1" size="small" type="primary" plain icon="el-icon-upload2">
                          {{ uptitle }}
                        </el-button>
                      </el-upload>
                    </el-form-item>
                    <p style="font-size:12px;color:var(--info-color)9;margin-top:10px;cursor: pointer;" @click="look">
                      请上传<span style="color:#4777E7">最新的营业执照，</span><span
                        style="color:red">证件需加盖与主体一致的单位公章、无公章的个体工商户可加盖法人私章或法人签字</span>
                    </p>
                    <p style="font-size:12px;color:var(--info-color)9;margin-top:3px">
                      加盖公章的扫描件或者复印件，支持.jpg .jpeg .bmp .gif
                      .png格式照片，大小不超过10M
                    </p>
                    <p v-if="fileshow" style="font-size:12px;color:#F56C6C;margin-top:3px">
                      请上传文件
                    </p>
                  </div>
                </div>
                <div style="margin-left:61px;margin-top:50px">
                  <p style="color:#2E384D;font-size:14px;margin-bottom: 7px;">
                    <span style="color:#F56C6C">*</span>统一社会信用代码：
                  </p>
                  <el-form-item prop="creditCode">
                    <el-input v-model.trim="enterpriseForm.creditCode" placeholder="请输入统一社会信用代码" style="width:962px"
                      size="small" @keydown.native="keydown($event)"></el-input>
                    <p style="font-size:12px;color:var(--info-color)9;height: 16px;line-height: 15px;margin-top:10px">
                      务必与营业执照上的注册号或统一社会信用代码一致
                    </p>
                  </el-form-item>
                </div>
                <div style="margin-left:61px;margin-top:50px">
                  <p style="color:#2E384D;font-size:14px;display:inline-block">
                    其他证明材料：
                  </p>
                  <div style="display:inline-block;vertical-align:top;width:80%">
                    <el-form-item prop="file2">
                      <el-upload :disabled="disabledone2" class="dataUpload" :action="action" :limit="10"
                        :on-success="dataOnSuccess2" :on-remove="dataOnRemove2" :before-upload="dataprogress2"
                        :headers="headers" :file-list="fileList2">
                        <el-button :disabled="disabledone2" size="small" type="primary" plain icon="el-icon-upload2">
                          上传文件
                        </el-button>
                      </el-upload>
                    </el-form-item>
                    <p style="font-size:12px;color:var(--info-color)9;margin-top:10px">
                      特殊情况可上传作为佐证，如企业工商变更证明、官方红头文件、加盖公章证明等。其他证明材料可上传最多10张
                    </p>
                  </div>
                </div>
              </div>
              <div class="personinfor">
                <div>
                  <p style="width:2px;height:12px;background:var(--theme-color);border-radius:8px;display:inline-block;"></p>
                  <span style="color:#323232;font-size:16px">企业负责人信息</span><span
                    style="font-size:12px;color:var(--info-color)9;margin-left:10px">企业创建者默认为负责人</span>
                </div>
                <div style="margin-left:61px;margin-top:30px">
                  <p style="color:#2E384D;font-size:14px;margin-bottom: 7px;">
                    <span style="color:#F56C6C">*</span>您的姓名：
                  </p>
                  <el-form-item prop="userName">
                    <el-input v-model.trim="enterpriseForm.userName" :placeholder="[
                      youuserName
                        ? '自动获取注册时填写的姓名，可更改'
                        : '请输入姓名',
                    ]" style="width:962px" maxlength="10" minlength="1" size="small" @keydown.native="keydown($event)">
                    </el-input>
                  </el-form-item>
                </div>
                <div style="margin-left:61px;margin-top:30px">
                  <p style="color:#2E384D;font-size:14px;margin-bottom: 7px;">
                    <span style="color:#F56C6C">*</span>您的身份证号码：
                  </p>
                  <el-form-item prop="idCard">
                    <el-input v-model.trim="enterpriseForm.idCard" placeholder="请输入您的身份证号" style="width:962px"
                      size="small" @keydown.native="keydown($event)"></el-input>
                  </el-form-item>
                </div>
                <div style="margin-left:61px;margin-top:30px">
                  <p style="color:#2E384D;font-size:14px;margin-bottom: 7px;">
                    <span style="color:#F56C6C">*</span>身份验证：
                  </p>
                  <el-form-item prop="verifyCode">
                    <el-input v-model.trim="enterpriseForm.verifyCode" placeholder="请输入短信验证码" style="width:962px"
                      size="small" @keydown.native="keydown($event)">
                      <p v-if="!time" slot="suffix" style="cursor: pointer;color:#1e6ef5" @click="huoquyanzhengma">
                        获取验证码
                      </p>
                      <p v-if="time" slot="suffix">
                        {{ time }}秒后可重新获取
                      </p>
                    </el-input>
                    <p style="font-size:12px;color:var(--info-color)9;height: 16px;line-height: 15px;margin-top:10px">
                      将给当前登录账户{{ qian }}****{{
                        hou
                      }}发送一条短信验证码，以确认为本人操作
                    </p>
                  </el-form-item>
                </div>
              </div>
              <div class="foot">
                <el-button v-if="fftype == '0'" type="primary" size="small" plain :loading="loadingnext"
                  @click="goenterprise">
                  上一步
                </el-button>
                <el-button type="primary" size="small" :loading="loadingnext"
                  @click="validationsuccee('enterpriseForm')">
                  下一步
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import steps from "@/CommonDP/components/steps";
import { uploadDataUrl, getToken, storage } from "@/CommonDP/utils";
import registerService from "@/CommonDP/service/register-service";
import EnterpriseHeader from "./components/userEnterHeader";
import { mapState } from "vuex";
export default {
  name: "Enterprise",
  components: {
    steps,
    EnterpriseHeader
  },
  data() {
    var validateshenfenzheng = (rule, value, callback) => {
      var num = value;
      var reg = /^(\d{18,18}|\d{15,15}|\d{17,17}X)$/;
      if (num === "") {
        callback(new Error("请输入您的身份证号码"));
      } else {
        if (reg.test(num)) {
          var len, re;
          len = num.length;
          if (len === 15) {
            re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
            var arrSplit = num.match(re);
            // 检查生日日期是否正确
            var dtmBirth = new Date("19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
            var bGoodDay;
            bGoodDay =
              dtmBirth.getYear() === Number(arrSplit[2]) &&
              dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
              dtmBirth.getDate() === Number(arrSplit[4]);
            if (!bGoodDay) {
              callback(new Error("身份证格式不正确!"));
            } else {
              callback();
            }
          } else if (len === 18) {
            re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
            const arrSplit = num.match(re);
            // 检查生日日期是否正确
            const dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
            const bGoodDay =
              dtmBirth.getFullYear() === Number(arrSplit[2]) &&
              dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
              dtmBirth.getDate() === Number(arrSplit[4]);
            if (!bGoodDay) {
              callback(new Error("身份证格式不正确!"));
            } else {
              // 检验18位身份证的校验码是否正确。
              // 校验位按照ISO 7064:1983.MOD
              // 11-2的规定生成，X可以认为是数字10。
              var valnum;
              const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
              const arrCh = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
              let nTemp = 0;
              for (let i = 0; i < 17; i++) {
                nTemp += num.substr(i, 1) * arrInt[i];
              }
              valnum = arrCh[nTemp % 11];
              if (valnum !== num.substr(17, 1)) {
                callback(new Error("身份证格式不正确!"));
              } else {
                callback();
              }
            }
          }
        } else {
          callback(new Error("身份证格式不正确!"));
        }
      }
    };
    var validateshehui = (rule, value, callback) => {
      var idCardx = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
      if (value === "") {
        callback(new Error("请输入统一社会信用代码"));
      } else if (!idCardx.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };
    var validateenterpriseName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入企业全称"));
      } else {
        this.repeat1 = callback;
        this.repeat2 = value;
        this.judgeenterpriseName();
      }
    };
    return {
      radio: "",
      input: "",
      stepsIndex: 1,
      stepsData: [{ name: "同意协议" }, { name: "填写资料" }, { name: "创建完成" }],
      name: "",
      nameshow: false,
      action: "",
      disabledone1: false,
      disabledone2: false,
      headers: {
        Authorization: "Bearer " + getToken()
      },
      fileList1: [],
      fileList2: [],
      enterpriseForm: {
        enterpriseName: "",
        creditCode: "",
        userName: "",
        idCard: "",
        verifyCode: "",
        enterpriseId: ""
      },
      rules: {
        enterpriseName: [{ required: true, validator: validateenterpriseName }],
        creditCode: [{ required: true, validator: validateshehui }],
        userName: [{ required: true, message: "请输入您的姓名" }],
        idCard: [{ required: true, validator: validateshenfenzheng }],
        verifyCode: [{ required: true, message: "请输入短信验证码" }]
      },
      qian: "",
      hou: "",
      time: 0,
      fileshow: false,
      phone: "",
      repeat1: "",
      repeat2: "",
      fftype: "0", // 0是正常填写 1是重新填写  重新填写 没有上一步
      id: "",
      uptitle: "上传文件",
      loadingnext: false,
      youuserName: "",
      width: "319"
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  created() {
    if (this.$route.query.fftype === "1") {
      this.fftype = this.$route.query.fftype;
      this.id = this.$route.query.id;
      this.queryd();
    }
    this.action = uploadDataUrl();
    this.enterpriseForm = JSON.parse(storage.get("setenterpriseForm"));
    this.fileList1 = this.enterpriseForm.fileList1;
    this.fileList2 = this.enterpriseForm.fileList2;
    this.enterpriseForm.userName = this.userInfo.name;
    this.youuserName = this.userInfo.name;
    this.phone = this.userInfo.username;
    this.qian = this.phone.slice(0, 3);
    this.hou = this.phone.slice(7, 11);
  },
  mounted() {
    const that = this;
    window.onbeforeunload = function (e) {
      if (that.$route.fullPath === "/fillinformation") {
        // 注意这里要替换成自己的当前页面的路由
        e = e || window.event;
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = "关闭提示";
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "关闭提示";
      } else {
        window.onbeforeunload = null;
      }
    };
  },
  methods: {
    keydown(event) {
      if (event.keyCode === 32) {
        event.returnValue = false;
      }
    },
    queryd() {
      registerService.getEnterpriseDetails(this.id).then((res) => {
        if (res.result === "0") {
          this.enterpriseForm.enterpriseName = res.data.enterpriseName;
          this.enterpriseForm.creditCode = res.data.creditCode;
          this.enterpriseForm.userName = res.data.name;
          this.enterpriseForm.idCard = res.data.idCard;
          this.enterpriseForm.enterpriseId = res.data.enterpriseId;
          if (res.data.businessLicenseFile) {
            this.fileList1.push(res.data.businessLicenseFile);
            this.fileList1[0].name = res.data.businessLicenseFile.fileName;
            this.uptitle = "重新上传";
          }
          if (res.data.otherFile.length) {
            for (var i = 0; i < res.data.otherFile.length; i++) {
              this.$set(res.data.otherFile[i], "name", res.data.otherFile[i].fileName);
            }
            this.fileList2 = res.data.otherFile;
          }
        }
      });
    },
    judgeenterpriseName() {
      var encoded = encodeURI(this.repeat2);
      registerService.enterprisegetByEnterpriseName(encoded).then((res) => {
        if (res.data) {
          if (res.data.enterpriseId === this.id) {
            this.repeat1();
          } else {
            this.repeat1(new Error("该企业全称已存在"));
          }
        } else {
          this.repeat1();
        }
      });
    },
    huoquyanzhengma() {
      var params = {
        phone: this.phone,
        smsTemplateId: "1094821"
      };
      registerService.smssendVerifyCode(params).then((res) => {
        if (res.result === "0") {
          this.time = 60;
          this.flushTime();
        }
      });
    },
    flushTime() {
      // console.log( 'flushTime' );
      const that = this;
      const intval = setInterval(function () {
        that.time--;
        if (that.time < 1) {
          that.time = 0;
          clearInterval(intval);
        }
      }, 1000);
    },
    // 上一步
    goenterprise() {
      var params = {
        enterpriseName: this.enterpriseForm.enterpriseName,
        creditCode: this.enterpriseForm.creditCode,
        userName: this.enterpriseForm.userName,
        idCard: this.enterpriseForm.idCard,
        verifyCode: this.enterpriseForm.verifyCode,
        fileList1: this.fileList1,
        fileList2: this.fileList2
      };
      storage.set("setenterpriseForm", JSON.stringify(params));
      // 判断是是来自无企业 还是注册
      if (this.$route.query.greetype) {
        this.$router.replace({
          path: "/consentagree",
          query: {
            greetype: this.$route.query.greetype,
            pagetype: this.$route.query.pagetype
          }
        });
      } else {
        this.$router.push("/consentagree");
      }
    },
    validationsuccee(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.fileList1.length) {
          this.loadingnext = true;
          var otherFileIds = [];
          for (var i = 0; i < this.fileList2.length; i++) {
            otherFileIds.push(this.fileList2[i].fileKey);
          }
          var params = {
            enterpriseName: this.enterpriseForm.enterpriseName,
            creditCode: this.enterpriseForm.creditCode,
            userName: this.enterpriseForm.userName,
            idCard: this.enterpriseForm.idCard,
            verifyCode: this.enterpriseForm.verifyCode,
            businessLicenseFileId: this.fileList1[0].fileKey,
            otherFileIds: otherFileIds,
            enterpriseId: this.enterpriseForm.enterpriseId
          };
          console.log(params, "params");
          // 重新修改企业信息
          if (this.id) {
            registerService
              .enterpriseupdate(params)
              .then((res) => {
                if (res.result === "0") {
                  this.loadingnext = false;
                  this.$router.push({
                    path: "/creationcomplete",
                    query: { id: res.data }
                  });
                }
              })
              .catch(() => {
                this.loadingnext = false;
              });
          } else {
            // 创建新企业
            registerService
              .enterprisecreate(params)
              .then((res) => {
                if (res.result === "0") {
                  this.loadingnext = false;
                  var data = this.userInfo;
                  data.name = this.enterpriseForm.userName;
                  data.token = getToken();
                  this.$store.dispatch("setUserInfo", data);
                  this.$router.replace({
                    path: "/creationcomplete",
                    query: { id: res.data }
                  });
                }
              })
              .catch(() => {
                this.loadingnext = false;
              });
          }
        } else {
          // console.log('失败');
          if (this.fileList1.length) {
            this.fileshow = false;
          } else {
            this.fileshow = true;
          }
          return false;
        }
      });
    },
    yanzheng() {
      if (this.nameshow) {
        this.name = "北京致一科技有限公司";
      } else {
        this.name = "您输入的邀请链接与账户信息不匹配，请确认后重试/您输入的邀请链接不存在，请确认后重试";
      }
    },
    dataOnSuccess1(response, file, fileList) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        this.disabledone1 = false;
        this.fileList1 = [];
        this.fileList1.push(response.data);
        this.uptitle = "重新上传";
        // console.log(this.fileList1,'this.fileList1');
        if (this.fileList1.length > 0) {
          this.fileshow = false;
        }
      }
    },
    dataOnRemove1({ fileKey }) {
      const index = this.fileList1.findIndex((item) => item.fileKey === fileKey);
      if (index > -1) {
        this.fileList1.splice(index, 1);
      }
      if (!this.fileList1.length) {
        this.fileshow = true;
        this.uptitle = "上传文件";
      }
    },
    dataprogress1(file) {
      this.disabledone1 = true;
      var tt = file.name;
      var ttt = tt.split(".");
      var ttl = ttt.length;
      const isJPEG = ttt[ttl - 1] === "jpeg";
      const isJPG = ttt[ttl - 1] === "jpg";
      const isBMP = ttt[ttl - 1] === "bmp";
      const isGIF = ttt[ttl - 1] === "gif";
      const isPNG = ttt[ttl - 1] === "png";
      const isPG = isJPG || isJPEG || isBMP || isGIF || isPNG;
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isPG) {
        this.disabledone1 = false;
        this.$message({
          showClose: true,
          message: "上传文件只能是 .jpg .jpeg .bmp .gif .png 格式!",
          type: "warning"
        });
      } else if (!isLt2M) {
        this.disabledone1 = false;
        this.$message({
          showClose: true,
          message: "上传文件大小不能超过 10M!",
          type: "warning"
        });
      }
      return isPG && isLt2M;
    },
    dataOnSuccess2(response, file, fileList) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        this.disabledone2 = false;
        this.fileList2.push(response.data);
        // console.log(this.fileList2,'this.fileList2');
      }
    },
    dataOnRemove2({ fileKey }) {
      const index = this.fileList2.findIndex((item) => item.fileKey === fileKey);
      if (index > -1) {
        this.fileList2.splice(index, 1);
      }
    },
    dataprogress2() {
      this.disabledone2 = true;
    },
    look() {
      const { href } = this.$router.resolve({ path: "/businesslicense" });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.fillinformation {
  // min-width: 1275px;
  width: 100%;
  // min-height: 937px;
  // height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    // min-height: 1000px;
    overflow-y: auto;
    // text-align: center;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .invitationlink {
      margin-left: 73px;
      margin-right: 73px;
      .qualificationinfor {
        margin-top: 30px;
      }
      .personinfor {
        margin-top: 36px;
      }
      .foot {
        text-align: center;
        margin-top: 90px;
        padding-bottom: 34px;
      }
      /deep/ .el-form-item {
        margin-bottom: 0px;
        .el-form-item__content {
          line-height: 0px;
        }
        .el-form-item__error {
          padding-top: 1px;
        }
        .el-input__prefix,
        .el-input__suffix {
          top: 16px;
          right: 12px;
        }
      }
    }
  }
}
</style>
